import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { useMemo, useState } from "react";
import {
    IConfigSerieRadarMultiples,
    RadarMultipleSeriesChart,
} from "../../../../Components/apexcharts/RadarMultipleSeriesChart";
import Expadir from "../../../../Components/Utils/Expandir";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import { ListarusuariosdashboardController } from "../../../../Controllers/Geral/Dashboard/DashboardController";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { IFiltrouserDashboard } from "../../../../Interfaces/Users/UsersInterface";
import { getXMonthsAgoDate } from "../../../../Tools/DateTools";
import { groupBy } from "../../../../Tools/ProcessingTools";
import FiltroUsuarioAtendimentoDash from "./FiltroUsuarioAtendimentoDash";
import IndicadoresAtendimento from "./IndicadoresAtendimento";

export default function UsuariosAtendimentos() {
    const filtroInicial: IFiltrouserDashboard = {
        DT_ABERTURA_INICIO: getXMonthsAgoDate(1).toISOString().split("T")[0],
    };

    const [filter, setFilter] = useState(filtroInicial);

    const { value: lstUsuariosDashboard, loading } =
        useAsyncEffect(async () => {
            return ListarusuariosdashboardController(filter ?? {});
        }, [filter]);

    const AtendimentosIndicadores = {
        NR_ATENDIMENTOS_ABERTOS: useMemo(
            () =>
                lstUsuariosDashboard?.reduce((sum, aa) => {
                    return (
                        sum +
                        aa.ATENDIMENTOS.reduce((sumIn, Obj) => {
                            return sumIn + (Obj.NR_ATENDIMENTOS_ABERTOS || 0);
                        }, 0)
                    );
                }, 0),
            [lstUsuariosDashboard]
        ),
        NR_ATENDIMENTOS_FECHADOS: useMemo(
            () =>
                lstUsuariosDashboard?.reduce((sum, aa) => {
                    return (
                        sum +
                        aa.ATENDIMENTOS.reduce((sumIn, Obj) => {
                            return sumIn + (Obj.NR_ATENDIMENTOS_FECHADOS || 0);
                        }, 0)
                    );
                }, 0),
            [lstUsuariosDashboard]
        ),
        NR_INTERACOES: useMemo(
            () =>
                lstUsuariosDashboard?.reduce((sum, aa) => {
                    return (
                        sum +
                        aa.ATENDIMENTOS.reduce((sumIn, Obj) => {
                            return sumIn + (Obj.NR_INTERACOES || 0);
                        }, 0)
                    );
                }, 0),
            [lstUsuariosDashboard]
        ),
        NR_ATENDIMENTOS: useMemo(
            () =>
                lstUsuariosDashboard?.reduce((sum, aa) => {
                    return (
                        sum +
                        aa.ATENDIMENTOS.reduce((sumIn, Obj) => {
                            return sumIn + (Obj.NR_ATENDIMENTOS || 0);
                        }, 0)
                    );
                }, 0),
            [lstUsuariosDashboard]
        ),
    };

    const Atendimentos = lstUsuariosDashboard
        ?.map((res) => {
            return res.ATENDIMENTOS;
        })
        ?.reduce((prev, current) => {
            return current.concat(prev);
        }, []);

    const arrayModulos = Array.from(
        groupBy(
            Atendimentos?.filter((a) => a.ID_TIPO_PESO_ATENDIMENTO) || [],
            (a) => a.DS_TIPO_CASO
        ).entries()
    ).map(([key, lst]) => ({
        ID_MODULO: lst[0].ID_TIPO_CASO ?? 0,
        DS_MODULO: key,
    }));
    const arrayTipoPeso: Array<string> = Array.from(
        groupBy(Atendimentos || [], (x) => x.DS_TIPO_PESO_ATENDIMENTO).keys()
    ).filter((x) => x !== "SemCadastro");

    const IndicadoresRadarAtendimento = {
        ArrayAbertos: [] as Array<number>,
        ArrayFechados: [] as Array<number>,
    };

    arrayTipoPeso.forEach((Arres) => {
        IndicadoresRadarAtendimento.ArrayAbertos.push(
            Atendimentos?.filter(
                (x) => x.DS_TIPO_PESO_ATENDIMENTO === Arres
            ).reduce((sum, aa) => {
                return sum + (aa.NR_ATENDIMENTOS_ABERTOS || 0);
            }, 0) || 0
        );
        IndicadoresRadarAtendimento.ArrayFechados.push(
            Atendimentos?.filter(
                (x) => x.DS_TIPO_PESO_ATENDIMENTO === Arres
            ).reduce((sum, aa) => {
                return sum + (aa.NR_ATENDIMENTOS_FECHADOS || 0);
            }, 0) || 0
        );
    });

    const AtendimentoRadar: Array<IConfigSerieRadarMultiples> = [
        {
            name: "Fechados",
            data: IndicadoresRadarAtendimento.ArrayFechados,
        },
        {
            name: "Abertos",
            data: IndicadoresRadarAtendimento.ArrayAbertos,
        },
    ];

    return (
        <>
            <IndicadoresAtendimento {...AtendimentosIndicadores} />
            <hr />
            <div className="card card-custom">
                <div className="card-header align-items-center justify-content-center">
                    <div className="text-center flex-grow-1">
                        <div className="text-dark-75 font-weight-bold font-size-h5">
                            Atendimento por Tipo Peso
                        </div>
                    </div>
                </div>
                <div className="card-body justify-content-end">
                    {lstUsuariosDashboard && (
                        <Expadir hideHR bonusIcon={faFilter} justify={"end"}>
                            <FiltroUsuarioAtendimentoDash
                                Modulos={arrayModulos}
                                lstUsuarios={lstUsuariosDashboard}
                                handleSubmit={setFilter}
                                default={filtroInicial}
                            />
                        </Expadir>
                    )}

                    <OrSpinner loading={loading} spinner="capys">
                        <RadarMultipleSeriesChart
                            series={AtendimentoRadar}
                            categories={arrayTipoPeso}
                        />
                    </OrSpinner>
                </div>
            </div>
        </>
    );
}
